import { useMemo } from 'react'
import type { ReactNode } from 'react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, Fetcher } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { financeReport, type FinanceRow } from './financeApi'

/**
 * A10 umumiy READ-ONLY jadval. MyGram ichki iqtisodidan (wallet_txns / points_ledger
 * / token_txns / bot_star_charges / market_trades / fraud_payments / referrals)
 * hisoblangan HAQIQIY ma'lumotni ko'rsatadigan barcha hisobot/ro'yxat ekranlari
 * (A10.03–08/10/16–18/22–24/27–31) shu bitta komponent orqali quriladi. Fetcher
 * ichkarida `/admin/finance/report/:name` ustidan barqaror identity bilan quriladi.
 */
export interface FinanceListTableProps {
  screenId: string
  title: string
  description?: string
  /** Backend report slug (`failed`, `by-provider`, …). */
  reportName: string
  searchKeys: string[]
  columns: AdminColumn<FinanceRow>[]
  icon: ReactNode
  rowId?: (r: FinanceRow) => string
}

export function FinanceListTable({
  screenId,
  title,
  description,
  reportName,
  searchKeys,
  columns,
  icon,
  rowId,
}: FinanceListTableProps) {
  const searchKeyStr = searchKeys.join('|')
  const fetcher = useMemo<Fetcher<FinanceRow>>(
    () => financeReport<FinanceRow>(reportName, searchKeyStr.split('|')),
    [reportName, searchKeyStr],
  )
  return (
    <>
      <PageHeader title={title} screenId={screenId} description={description} />
      <DataTable<FinanceRow>
        screenId={screenId}
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={rowId ?? ((r) => String(r.id))}
        exportable
        emptyState={{ icon }}
      />
    </>
  )
}
